import { Stack } from '@mui/material';
import { AnalysisSelectionNew } from 'enums';
import _ from 'lodash';
import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Assessment } from 'types/analysis-result.types';
import { ProfileValues } from 'types/profile.types';
import AnalysisTabBar from './analysis-tab-bar';
import AnalysisTabContent from './analysis-tab-content';
import ContactPersona from './contact-persona';

interface Props {
  contactName: string | undefined;
  contactOccupation: string | undefined;

  contactAssessment: Assessment | undefined;
  contactProfile: ProfileValues | undefined;
  userProfile?: ProfileValues;
}

const ContactAnalysisResults: React.FC<Props> = ({ contactName, contactOccupation, contactAssessment, contactProfile, userProfile }) => {
  const { classes } = useStyles();

  const [selectedAnalysis, setSelectedAnalysis] = useState<AnalysisSelectionNew>(AnalysisSelectionNew.PERSONALITY_TYPE);

  const handleSelectedAnalysisChange = (newSelection: AnalysisSelectionNew) => {
    return () => {
      setSelectedAnalysis(newSelection);
    };
  };

  return (
    <Stack className={classes.analysis} gap={1}>
      {!_.isNil(contactAssessment) ? (
        <ContactPersona contactName={contactName} contactOccupation={contactOccupation} assessment={contactAssessment} />
      ) : null}
      <AnalysisTabBar selectedAnalysis={selectedAnalysis} handleSelectedAnalysisChange={handleSelectedAnalysisChange} />
      <AnalysisTabContent
        contactName={contactName}
        selectedAnalysis={selectedAnalysis}
        contactAssessment={contactAssessment}
        contactProfile={contactProfile}
        userProfile={userProfile}
      />
    </Stack>
  );
};

const useStyles = makeStyles()(() => ({
  analysis: {
    padding: '8px',
    height: 'calc(100% - 36px)',
  },
}));

export default ContactAnalysisResults;
